import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../../api/api";

export default function LegalEntityUpdatePage() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [form, setForm] = useState({});
    const [error, setError] = useState("");

    useEffect(() => {
        load();
    }, []);

    const load = async () => {
        try {
            const { data } = await api.get(`/LegalEntity/${id}`);
            setForm(data);
        } catch {
            setError("Failed to load");
        }
    };

    const handleChange = e => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async e => {
        e.preventDefault();

        try {
            await api.put("/LegalEntity", form);
            navigate("/admin/legal");
        } catch {
            setError("Update failed");
        }
    };

    return (
        <div className="p-6 bg-white rounded shadow">
            <h2 className="text-xl font-bold mb-4">Update</h2>

            <form onSubmit={handleSubmit} className="space-y-3">
                <input name="companyName" value={form.companyName || ""} onChange={handleChange} className="input" />
                <input name="taxId" value={form.taxId || ""} onChange={handleChange} className="input" />

                <button className="bg-indigo-600 text-white px-4 py-2 rounded">
                    Save
                </button>

                {error && <p className="text-red-600">{error}</p>}
            </form>
        </div>
    );
}